<template lang="pug">
label.toggle-switch-wrapper
  input(
    type="checkbox"
    autocomplete="off"
    :checked="value"
    :disabled="disabled"
    @click="onClick"
  )
  .toggle-switch
  span.toggle-switch-label
    slot
</template>

<script>
export default {
  name: 'AppOnOffToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(event) {
      this.$emit('input', !this.value, event);
    },
  },
};
</script>
